<template>
  <section>
    <v-toolbar color="#9190b5" dark prominent src="https://picsum.photos/1920/1080?random">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>
      <v-toolbar-title>{{ $route.name }}</v-toolbar-title>
      <v-spacer/>
      <template v-slot:extension>
        <v-text-field v-model="table_data.search" clearable flat dense solo-inverted hide-details
                      prepend-inner-icon="mdi-magnify" label="Search"
        />
      </template>
    </v-toolbar>

<!--    <v-toolbar class="box-shadow">-->
<!--      <v-text-field v-model="table_data.search" clearable flat dense solo-inverted hide-details-->
<!--                    prepend-inner-icon="mdi-magnify" label="Search"-->
<!--      />-->
<!--    </v-toolbar>-->

    <v-container fluid>
      <v-row>
        <v-col cols="12" md="3">
          <v-card>
            <v-card-text class="text-center">
              <v-btn-toggle v-model="period" mandatory color="primary">
                <v-btn small value="default">Default</v-btn>
                <v-btn small value="today">Today</v-btn>
                <v-btn small value="tomorrow">Tomorrow</v-btn>
<!--                <v-btn small value="3month">3 months</v-btn>-->
<!--                <v-btn small value="6month">6 months</v-btn>-->
<!--                <v-btn small value="all">All</v-btn>-->
              </v-btn-toggle>
            </v-card-text>
            <v-divider/>
            <v-card-text>
              <date-field input-class="mx-2" flat dense solo-inverted label="From" v-model="date_from" clearable/>
              <date-field input-class="mx-2" flat dense solo-inverted label="Till" v-model="date_to" clearable/>
            </v-card-text>
            <v-divider/>
            <v-card-text>
              <v-select label="Practice area" class="px-1"
                        :items="practice_areas"
                        v-model="table_data.practice_area"
                        item-value="id"
                        item-text="name"
                        clearable dense solo-inverted
                        @change="$router.replace({name: $route.name, query: {...$route.query, practice_area: table_data.practice_area}})"
              />
              <v-select label="Session type" class="px-1"
                        :items="session_types"
                        v-model="table_data.session_type"
                        item-value="id"
                        item-text="name"
                        clearable dense solo-inverted
                        @change="$router.replace({name: $route.name, query: {...$route.query, session_type: table_data.session_type}})"
              />

              <v-select label="Assigment status" class="px-1"
                        :items="assigment_status_opts"
                        v-model="assigment_status"
                        clearable dense solo-inverted
                        @change="$router.replace({name: $route.name, query: {...$route.query, assigment_status: assigment_status}})"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="9" class="pl-md-0">
          <v-card>
            <v-data-table :headers="table_data_headers"
                          :items="table_data_items"
                          :search="table_data.search"
                          :items-per-page="15"
            >
              <template v-slot:item.start="{ value }">
                {{ $moment(value).format("DD/MM/YYYY hh:mm A") }}
              </template>
              <template v-slot:item.deadline="{ value }">
                {{ value ? $moment(value).format("DD/MM/YYYY hh:mm A") : null }}
              </template>
              <template v-slot:item.end="{ value }">
                {{ $moment(value).format("DD/MM/YYYY hh:mm A") }}
              </template>
              <template v-slot:item.ready="{ item }">
                <template v-if="item.ready">
                  <template v-if="$moment(item.deadline).isBefore($moment(item.ready))">
                    <v-icon color="error">mdi-alarm</v-icon>
                    <span> {{ $moment(item.ready).format("DD/MM/YYYY hh:mm A") }}</span>
                  </template>
                  <template v-else>
                    <v-icon color="success" v-if="item.ready">mdi-checkbox-marked-circle</v-icon>
                    <span> {{ $moment(item.ready).format("DD/MM/YYYY hh:mm A") }}</span>
                  </template>
                </template>
              </template>
<!--              <template v-slot:item.ready="{ value }">-->
<!--                <v-icon color="success" v-if="value">mdi-checkbox-marked-circle</v-icon>-->
<!--              </template>-->
              <template v-slot:item.marked="{ value }">
                <v-icon color="success" v-if="value">mdi-checkbox-marked-circle</v-icon>
              </template>
              <template v-slot:item.final_mark="{ item }">
                <template v-if="item.marked">{{ item.final_mark }}</template>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn small color="primary"
                       class="box-shadow"
                       :to="{name: 'Classroom session', params: {session_id: item.id}}">open</v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  data: () => ({
    table_data: {
      items: [],
      search: '',
      practice_area: null,
      session_type: null,
    },
    period: 'default',
    period_opts: [
        'default',
        'today',
        'tomorrow',
        '3month',
        '6month',
        'all',
    ],

    date_from: null,
    date_to: null,
    events: [],
    assigment_status: null,
    assigment_status_opts: [
      {text: 'Waiting', value: 'waiting'},
      {text: 'Submitted for marking', value: 'submitted'},
      {text: 'Marked submissions', value: 'marked'},
    ],
  }),
  computed: {
    ...mapGetters({
      profile_type: 'getAuthUserProfileType',
      session_types: 'getSessionTypes',
      practice_areas: 'getPracticeAreas',
    }),
    table_data_headers: function () {
      let headers = [
        { text: 'Mock', value: 'short_name' },
        // { text: 'Short Name', value: 'short_name' },
        // { text: 'Accessor', value: 'accessor.public_id' },

        // { text: 'Session type', value: 'session_type.name' },
        // { text: 'Practice area', value: 'practice_area.name' },
        { text: 'Date', value: 'start' },
        { text: 'Submit by', value: 'deadline' },
        { text: 'Submitted', value: 'ready' },
        { text: 'Marked by', value: 'end' },
        // { text: 'Marked', value: 'marked' },
        { text: 'Mark', value: 'final_mark' },
        // { text: 'Attendance note', value: 'include_an' },
        // { text: 'Status', value: 'status', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ]
      if(this.profile_type && this.profile_type === 'tutoringSolicitor') {
        headers.unshift({ text: 'Candidate', value: 'user.full_name' },)
      }
      if(this.profile_type && this.profile_type === 'interviewer') {
        headers.unshift({ text: 'Candidate', value: 'user.full_name' },)
      }
      return headers
    },
    table_data_items: function () {
      let items = []

      items.push(...this.table_data.items)

      if (this.profile_type === 'tutoringSolicitor' || this.profile_type === 'interviewer') {
        items = items.filter(item => {
          if(item.deadline && !item.ready) return ;
          return item
        })
      }

      if(this.date_from && this.date_to) {
        let date_from = this.$moment(this.date_from, 'YYYY-MM-DD');
        let date_to = this.$moment(this.date_to, 'YYYY-MM-DD');
        let filter_range = this.$moment.range(date_from, date_to);

        items = items.filter(item => {
          if(filter_range.contains(this.$moment(item.start, 'YYYY-MM-DD'))) return item
          if(filter_range.contains(this.$moment(item.end, 'YYYY-MM-DD'))) return item
          let start = this.$moment(item.start, 'YYYY-MM-DD')
          let end = this.$moment(item.end, 'YYYY-MM-DD')
          let item_range = this.$moment.range(start, end);

          if(item_range.contains(this.$moment(date_from, 'YYYY-MM-DD'))) return item
          if(item_range.contains(this.$moment(date_to, 'YYYY-MM-DD'))) return item
        })
      }

      if(this.table_data.practice_area) {
        items = items.filter(item => item.practice_area_id === this.table_data.practice_area)
      }
      if(this.table_data.session_type) {
        items = items.filter(item => item.session_type_id === this.table_data.session_type)
      }
      if(this.assigment_status) {
        if (this.assigment_status === 'waiting') {
          items = items.filter(item => item.ready === null && item.marked === null)
        }

        if (this.assigment_status === 'submitted') {
          items = items.filter(item => item.ready !== null && item.marked === null)
        }

        if (this.assigment_status === 'marked') {
          items = items.filter(item => item.ready !== null && item.marked !== null)
        }
      }

      return items
    },
  },
  watch: {
    'period': function (val) {
      switch(val) {
        case 'today':
          this.date_from = this.$currentTime().format('YYYY-MM-DD')
          this.date_to = this.$currentTime().format('YYYY-MM-DD')
          break;
        case 'tomorrow':
          this.date_from = this.$currentTime().add(1, 'days').format('YYYY-MM-DD')
          this.date_to = this.$currentTime().add(1, 'days').format('YYYY-MM-DD')
          break;
        case '3month':
          this.date_from = this.$currentTime().subtract(3, 'month').format('YYYY-MM-DD')
          this.date_to = this.$currentTime().add(10, 'days').format('YYYY-MM-DD')
          break;
        case '6month':
          this.date_from = this.$currentTime().subtract(6, 'month').format('YYYY-MM-DD')
          this.date_to = this.$currentTime().add(10, 'days').format('YYYY-MM-DD')
          break;

        // case 'all':
        //   this.date_from = null
        //   this.date_to = null
        //   break;
        default:
          this.date_from = this.$currentTime().format('YYYY-MM-DD')
          this.date_to = this.$currentTime().add(10, 'days').format('YYYY-MM-DD')
      }
    },
    // 'date_from': function() {
    //   this.loadData()
    // },
    // 'date_to': function() {
    //   this.loadData()
    // },
  },
  mounted() {

    if(this.$route.query.practice_area) this.table_data.practice_area = parseInt(this.$route.query.practice_area)
    if(this.$route.query.session_type) this.table_data.session_type = parseInt(this.$route.query.session_type)
    if(this.$route.query.assigment_status) this.assigment_status = this.$route.query.assigment_status
    this.date_from = this.$currentTime().format('YYYY-MM-DD')
    this.date_to = this.$currentTime().add(10, 'days').format('YYYY-MM-DD')
    this.loadData()
  },
  methods: {
    loadData() {
      this.axios.get('api/user/sessions', {params: {date_from: this.date_from, date_to: this.date_to}})
          .then(({data}) => { this.table_data.items = data.data })
    },
  }
}
</script>
